import { Component } from '@angular/core';
import {
  EntityContainerModel, SupplierService
} from 'blg-akaun-ts-lib';
import { DropDownComponent } from '../drop-down.component';
import { SupplierDropDown } from './supplier.options';

@Component({
  selector: 'blg-select-supplier-drop-down',
  templateUrl: '../drop-down.component.html',
  styleUrls: ['../drop-down.component.scss']
})

export class SelectSupplierDropDownComponent extends DropDownComponent<EntityContainerModel> {
  options = new SupplierDropDown(this.supplierService, 'Key in Supplier Code/Name');

  constructor(
    private supplierService: SupplierService,
  ) {
    super();
  }
}
